import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import {
    AdminPage,
    AdminPageBody,
    AdminPageHeader,
} from '@apps/web/features/admin_design/admin_shell';
import { AdminTabs } from '@apps/web/features/admin_design/admin_tabs';
import { ColorStudyShowcase } from '@apps/web/routes/_app/admin/ui_components_color';
import { DomainComponentsShowcase } from '@apps/web/routes/_app/admin/ui_components_domain';
import { IconsShowcase } from '@apps/web/routes/_app/admin/ui_components_icons';
import { SharedComponentsShowcase } from '@apps/web/routes/_app/admin/ui_components_shared';
import { V3EventComponentsGallery } from '@apps/web/routes/_app/admin/v3_event_components';

export const Route = createFileRoute('/_app/admin/ui-components')({
    component: UIComponentsCatalog,
    head: () => ({
        meta: [
            {
                title: 'UI Components | Phoebe Admin',
            },
        ],
    }),
});

type CatalogTab = 'shared' | 'domain' | 'v3' | 'color' | 'icons';

const CATALOG_TABS = [
    { value: 'shared', label: 'Shared' },
    { value: 'domain', label: 'Domain' },
    { value: 'v3', label: 'v3 agent' },
    { value: 'color', label: 'Color' },
    { value: 'icons', label: 'Icons' },
] satisfies ReadonlyArray<{
    readonly value: CatalogTab;
    readonly label: string;
}>;

function UIComponentsCatalog() {
    const [tab, setTab] = useState<CatalogTab>('shared');
    return (
        <AdminPage>
            <AdminPageHeader title="UI Components" meta="apps/web">
                <AdminTabs
                    items={CATALOG_TABS}
                    value={tab}
                    onValueChange={(value) => setTab(value as CatalogTab)}
                    aria-label="Component catalogs"
                />
            </AdminPageHeader>
            <AdminPageBody>
                {tab === 'shared' ? <SharedComponentsShowcase /> : null}
                {tab === 'domain' ? <DomainComponentsShowcase /> : null}
                {tab === 'v3' ? <V3EventComponentsGallery /> : null}
                {tab === 'color' ? <ColorStudyShowcase /> : null}
                {tab === 'icons' ? <IconsShowcase /> : null}
            </AdminPageBody>
        </AdminPage>
    );
}
